import { StateFrom } from 'xstate';
import { useInterpret, useSelector } from '@xstate/react';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';

import { fetchPreviewUsers } from 'api/queries/predictiveAudiences';
import {
  GoalPreviewStates,
  GoalPreviewMachine,
  createGoalPreviewMachineEffects,
} from './usePreviewUsers.state';
import { PredictiveGoalQuery } from '../../../types';

export const usePreviewUsers = () => {
  const { fetch: queryPreviewUsers } = useLazyGraphql(fetchPreviewUsers, {
    fetchPolicy: 'no-cache',
  });
  const service = useInterpret(
    GoalPreviewMachine,
    createGoalPreviewMachineEffects({
      queryPreviewUsers,
    }),
  );
  const isLoading = useSelector(service, (state: StateFrom<typeof GoalPreviewMachine>) =>
    state.matches(GoalPreviewStates.queryGoalPreview),
  );
  const isExtendedLoading = useSelector(service, (state: StateFrom<typeof GoalPreviewMachine>) => {
    return state.context.isExtendedLoading;
  });
  const isReady = useSelector(service, (state: StateFrom<typeof GoalPreviewMachine>) =>
    state.matches(GoalPreviewStates.ready),
  );
  const isError = useSelector(service, (state: StateFrom<typeof GoalPreviewMachine>) =>
    state.matches(GoalPreviewStates.error),
  );
  const previewUsersCount = useSelector(service, (state) => state.context.totalCount);

  return {
    isContentReady: isReady || isError,
    isError,
    isExtendedLoading,
    isLoading,
    previewUsersCount,
    queryGoalPreview: (goal: PredictiveGoalQuery) => {
      service.send(GoalPreviewStates.queryGoalPreview, { goal });
    },
    service,
  };
};
